import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import NavBar from '../../components/layout/NavBar'
// import ModelViewer from '../../components/common/ModelViewer'
import Footer from '../../components/layout/Footer'
import './Partners.css'

const Partners = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    businessName: '',
    message: ''
  })
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [submitStatus, setSubmitStatus] = useState(null)

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsSubmitting(true)
    setSubmitStatus(null)
    
    try {
      // Use our secure Firebase backend instead of client-side EmailJS
      const response = await fetch('/api/partners-inquiry', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...formData,
          type: 'partner_inquiry' // Distinguish from regular contact
        })
      })

      if (response.ok) {
        const result = await response.json()
        console.log('✅ Partner inquiry submitted successfully:', result)
        
        setSubmitStatus('success')
        
        // Clear form
        setFormData({
          name: '',
          email: '',
          businessName: '',
          message: ''
        })
        
        // Clear success message after 5 seconds
        setTimeout(() => setSubmitStatus(null), 5000)
      } else {
        const errorData = await response.json()
        console.error('❌ Partner inquiry submission failed:', errorData)
        setSubmitStatus('error')
        setTimeout(() => setSubmitStatus(null), 5000)
      }
    } catch (error) {
      console.error('❌ Partner inquiry network error:', error)
      setSubmitStatus('error')
      setTimeout(() => setSubmitStatus(null), 5000)
    } finally {
      setIsSubmitting(false)
    }
  }

  const publicUrl = process.env.PUBLIC_URL || '';

  return (
    <div 
      className="getstarted-container"
      style={{ '--getstarted-background-image': `url(${publicUrl}/20250509_Sun_Block.png)` }}
    >
      <Helmet>
        <title>Get Started - block automation</title>
        <meta property="og:title" content="Get Started - block automation" />
        <meta property="og:description" content="Get started with block automation" />
      </Helmet>
      <NavBar />
      
      {/* Styles for this section are now primarily in Partners.css */}
      <div className="getstarted-section section-container">
        <div className="getstarted-max-width max-width">
          <div className="getstarted-content">
            <span className="getstarted-text beforeHeading">get started</span>
            <h1 className="getstarted-text-title">
              <span>
                Ready to enhance your venue with 
                <span dangerouslySetInnerHTML={{ __html: ' ' }} />
              </span>
              {/* Specific color for Sun Blocks can remain if it's unique */}
                              <strong className="brand-orange">Sun Blocks</strong> 
              <span>?</span>
            </h1>
            <div className="getstarted-step">
              <div className="getstarted-number">
                <span className="getstarted-step-number">1</span>
              </div>
              <div className="getstarted-container-step">
                <span className="getstarted-title-step">
                  <span>
                    Fill out the
                    <span dangerouslySetInnerHTML={{ __html: ' ' }} />
                  </span>
                  <span className="getstarted-text-orange">contact form</span>
                  <span> below</span>
                </span>
                <span className="getstarted-description">
                  We'll get back to you within 24 hours to discuss how we can help your guests stay protected.
                </span>
              </div>
            </div>
            <div className="getstarted-step">
              <div className="getstarted-number">
                <span className="getstarted-step-number">2</span>
              </div>
              <div className="getstarted-container-step">
                <span className="getstarted-title-step">
                  <span>
                    Schedule a
                    <span dangerouslySetInnerHTML={{ __html: ' ' }} />
                  </span>
                  <span className="getstarted-text-orange">
                    friendly demo
                  </span>
                </span>
                <span className="getstarted-description">
                  We'll show you how <strong className="brand-orange">Sun Blocks</strong> works and answer any questions you have about implementation at your venue.
                </span>
              </div>
            </div>
            <div className="getstarted-step">
              <div className="getstarted-number">
                <span className="getstarted-step-number">3</span>
              </div>
              <div className="getstarted-container-step">
                <span className="getstarted-title-step">
                  <span>
                    Try it
                    <span dangerouslySetInnerHTML={{ __html: ' ' }} />
                  </span>
                  <span className="getstarted-text-orange">risk-free</span>
                </span>
                <span className="getstarted-description">
                  We're happy to let you trial a <strong className="brand-orange">Sun Blocks</strong> dispenser at no cost so you can see firsthand how your guests love this amenity.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Contact Form Section (from contact.js) */}
      <div className="getstarted-form-container section-container">
        <div className="max-width">
          <div className="getstarted-form-content">
            <h1 className="getstarted-form-title">Schedule Your Demo</h1>
            <p className="getstarted-form-description">
              Let us show you how <strong className="brand-orange">Sun Blocks</strong> can enhance your guest experience and provide a valuable amenity to your venue.
            </p>
            <form className="getstarted-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Name</label>
                <input 
                  type="text" 
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Your name" 
                  required 
                />
              </div>
              <div className="form-group">
                <label>Email</label>
                <input 
                  type="email" 
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Your email" 
                  required 
                />
              </div>
              <div className="form-group">
                <label>Business Name</label>
                <input 
                  type="text" 
                  name="businessName"
                  value={formData.businessName}
                  onChange={handleChange}
                  placeholder="Your business name" 
                  required 
                />
              </div>
              <div className="form-group">
                <label>Message</label>
                <textarea 
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Tell us about your venue and what you're looking for" 
                  required
                ></textarea>
              </div>
              
              {/* SUCCESS MESSAGE */}
              {submitStatus === 'success' && (
                <div className="alert alert-success" style={{
                  backgroundColor: '#d4edda',
                  color: '#155724',
                  padding: '12px 16px',
                  borderRadius: '8px',
                  marginBottom: '16px',
                  border: '1px solid #c3e6cb'
                }}>
                  ✅ <strong>Message sent successfully!</strong> We'll get back to you within 24 hours.
                </div>
              )}

              {/* ERROR MESSAGE */}
              {submitStatus === 'error' && (
                <div className="alert alert-error" style={{
                  backgroundColor: '#f8d7da',
                  color: '#721c24',
                  padding: '12px 16px',
                  borderRadius: '8px',
                  marginBottom: '16px',
                  border: '1px solid #f5c6cb'
                }}>
                  ❌ <strong>Failed to send message.</strong> Please try again or email us directly at trevor@blockautomation.ai
                </div>
              )}
              
              <button 
                type="submit" 
                className="button button-primary"
                disabled={isSubmitting}
                style={{
                  opacity: isSubmitting ? 0.6 : 1,
                  cursor: isSubmitting ? 'not-allowed' : 'pointer'
                }}
              >
                {isSubmitting ? '🔄 Sending...' : 'Schedule My Demo'}
              </button>
            </form>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default Partners
